import { render } from "./FooterBar.vue?vue&type=template&id=06c86146"
const script = {}

import "./FooterBar.vue?vue&type=style&index=0&id=06c86146&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__